import "./App.css";
import Hero from "./components/Hero/Hero";
import Programs from "./components/Programs/Programs";
import Reasons from "./components/Reasons/Reasons";
import Brands from "./components/Brands/Brands";
import Team from "./components/Team/Team";
import Testimonials from "./components/Testimonials/Testimonials";
import Contact from "./components/Contact/Contact";
import Schedule from "./components/Schedule/Schedule";
import Footer from "./components/Footer/Footer";
function App() {
  return (
    <div className="App">
      <Hero />
      <Programs />
      <Reasons />
      <Team />
      <Schedule />
      <Testimonials />
      <Contact/>
      <Brands />
      <Footer />
    </div>
  );
}

export default App;
